import React from 'react';
import { AiOutlineShoppingCart, AiOutlineHeart, AiOutlineEye } from 'react-icons/ai';
import { Global } from '../Variables/Global';
import { Link } from 'react-router-dom';

const ProductListAR = (props) => {

    const isInWishlist = props.WishListItems?.some(
        item => item.ProductId === props.product.ProductId
    );

    return (
        <>
            <div className="gf-product shop-list-view-product">

                <div className="product-content directionRtl">
                    <div className="product-categories">
                        {/* <a href="shop-left-sidebar.html">JALLAB - SYRUP</a> */}
                    </div>
                    <h3 className="product-title"><a href={"/AR/DetailedProduct/" + props.product.ProductName.replace(/ /g, "-") + "/" + props.product.ProductId + "/" + props.product.DefaultVariation.ProductVariationId} className='RemUnderline' dangerouslySetInnerHTML={{ __html: props.product.ProductNameAR }}></a></h3>

                    <div className="price-box mb-2">
                        {
                            props.product.DefaultVariation.SalePrice === 0 ? (
                                <>
                                    <span className="discounted-price RemUnderline">AED{props.product.DefaultVariation.RegularPrice}</span>

                                </>
                            ) : (
                                <>
                                    <span className="discounted-price RemUnderline">AED{props.product.DefaultVariation.SalePrice}</span>
                                    <span className="main-price RemUnderline">AED{props.product.DefaultVariation.RegularPrice}</span>
                                </>
                            )
                        }
                    </div>
                    {/* <p className="product-description" dangerouslySetInnerHTML={{ __html: props.product.DescriptionAR }}></p> */}
                    <div className="list-product-icons me-2" >
                        <a data-tooltip="أضف إلى سلة التسوق" style={{ zIndex: '999' }} href={"/AR/DetailedProduct/" + props.product.ProductName.replace(/ /g, "-") + "/" + props.product.ProductId + "/" + props.product.DefaultVariation.ProductVariationId}>
                            {/* <span className="icon_cart_alt"></span> */}
                            <AiOutlineShoppingCart className='mb-1' style={{ color: 'white' }} />

                        </a>
                        {
                            isInWishlist ? (
                                <a
                                    data-tooltip="إزالة من المفضلة"
                                    onClick={() =>
                                        props.HandleRemoveFromWishList(props.product.ProductId)
                                    }
                                    style={{ marginLeft: "10px" }}
                                >
                                    <AiOutlineHeart className="mb-1" style={{ color: "white" }} />
                                </a>
                            ) : (
                                <a
                                    data-tooltip="أضف إلى المفضلة"
                                    onClick={() =>
                                        props.HandleAddToWishList(
                                            props.product.ProductId,
                                            props.product.DefaultVariation.ProductVariationId
                                        )
                                    }
                                    style={{ marginRight: "10px" }}
                                >
                                    <AiOutlineHeart className="mb-1" style={{ color: "white" }} />
                                </a>
                            )
                        }
                    </div>
                </div>
                <div className="image">
                    {!props.product.InStock && (
                        <span className="out-of-stock-badge">
                            نفد من المخزون
                        </span>
                    )}
                    <span href={"/AR/DetailedProduct/" + props.product.ProductName.replace(/ /g, "-") + "/" + props.product.ProductId + "/" + props.product.DefaultVariation.ProductVariationId}>
                        {/* <span className="onsale">Sale!</span> */}
                        {
                            props.product.DefaultVariation.Image2 == "" ? (
                                <Link to={"/AR/DetailedProduct/" + props.product.ProductName.replace(/ /g, "-") + "/" + props.product.ProductId + "/" + props.product.DefaultVariation.ProductVariationId}>
                                    <img src={Global.PHOTO_URL + props.product.DefaultVariation.Image1} alt={props.product.ProductName} />
                                    {/* onMouseOver={e => (e.currentTarget.src = Global.PHOTO_URL + product.Image1)}
                      onMouseOut = {e => (e.currentTarget.src = Global.PHOTO_URL + product.Image0)}  */}
                                </Link>
                            ) : (
                                <Link to={"/AR/DetailedProduct/" + props.product.ProductName.replace(/ /g, "-") + "/" + props.product.ProductId + "/" + props.product.DefaultVariation.ProductVariationId}>
                                    <img src={Global.PHOTO_URL + props.product.DefaultVariation.Image1} alt={props.product.ProductName}
                                        onMouseOver={e => (e.currentTarget.src = Global.PHOTO_URL + props.product.DefaultVariation.Image2)}
                                        onMouseOut={e => (e.currentTarget.src = Global.PHOTO_URL + props.product.DefaultVariation.Image1)}
                                    />

                                </Link>
                            )
                        }
                    </span>
                    {/* <div className="product-hover-icons">
                        <a data-tooltip="نظرة سريعة" onClick={() => {props.setShowModal(true);props.setProductDetails(props.product)}}>
                            <AiOutlineEye className='mb-1' style={{ color: 'white' }} />
                        </a>
                    </div> */}
                </div>

            </div>
        </>
    )
}

export default ProductListAR